import _ from "lodash";
import { toNString } from "../helpers/guids";
import { useAuth } from "react-oidc-context";
import { ClientReportType } from "../types/ClientReportType";

export type ClientReportControlOptions = {
    isAllowedToAssignAuthor: boolean,
    isAllowedToChangeReportCategories: boolean,
    isAllowedToChangeReportFeedback: boolean,
    isAllowedToChangeReportType: boolean,
    isAllowedToChangeReportFeedbackResponse: boolean,
    isReportEditable: boolean
};

export const allowAssignAuthorRoles = ["report_assign_author"];
export const allowChangeReportCategoryRoles = ["report_doc_management"];
export const allowChangeReportFeedbackRoles = ["report_doc_management"];
export const allowChangeReportTypeRoles = ["report_doc_management"];
export const useClientReportControls = (report: ClientReportType | null | undefined) : ClientReportControlOptions => {
    const auth = useAuth();
    const { roles, sub } = auth.user!.profile;
    const { adviserId, authorId, complianceUserId, isStatusCompliant, isStatusTerminated } = report || { isStatusCompliant: false, isStatusTerminated: false };
    const isReportEditable = isStatusCompliant === false && isStatusTerminated === false;

    const isAllowedToAssignAuthor = isReportEditable === true && _.some(roles, i => allowAssignAuthorRoles.includes(i));
    const isAllowedToChangeReportCategories = isReportEditable === true && _.some(roles, i => allowChangeReportCategoryRoles.includes(i));
    const isAllowedToChangeReportType = isReportEditable === true && _.some(roles, i => allowChangeReportTypeRoles.includes(i));
    
    const isAllowedToChangeReportFeedback = isReportEditable === true && (
        complianceUserId === toNString(sub) ||
        _.some(roles, i => allowChangeReportFeedbackRoles.includes(i))
    );
    
    const isAllowedToChangeReportFeedbackResponse = isReportEditable === true && (
        adviserId === toNString(sub) ||
        authorId === toNString(sub)
    );

    return {
        isAllowedToAssignAuthor,
        isAllowedToChangeReportCategories,
        isAllowedToChangeReportFeedback,
        isAllowedToChangeReportType,
        isAllowedToChangeReportFeedbackResponse,
        isReportEditable
    }
};